<template>
  <div class="backStack-issue-wrap">
    <UserInfos ref="userInfos" :infos="formInfo"></UserInfos>
    <UserInfos ref="userInfos" :infos="userInfo"></UserInfos>
    <div
      class="backStack-detail-footer-wrap"
      :style="{
        background: demandStatusOpt.background,
        border: demandStatusOpt.border
      }"
    >
      <a-row :gutter="[25, 14]">
        <a-col :span="4">
          <span class="label">审核状态：</span>
        </a-col>
        <a-col :span="20">
          <span :style="{ color: demandStatusOpt.color }">{{
            demandStatusOpt.text
          }}</span>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import UserInfos from '../../components/userInfos/index.vue'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { formInfo, userInfo } from './configs/formOptions.js'

import { getOperationDetail } from '@/api/operationInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: true,
      formInfo,
      userInfo,
      auditStatus: {
        '0': {
          background: '#F8F9FA',
          color: '#333',
          text: '未审核'
        },
        '1': {
          background: '#deeefe',
          border: '1px solid #65B1FF',
          color: '#2279D2',
          text: '已审核'
        },
        '2': {
          background: '#feebee',
          border: '1px solid #F51F3D',
          color: '#F5222D',
          text: '审核不通过'
        }
      },
      demandStatusOpt: '-'
    }
  },
  components: {
    UserInfos
  },
  created() {
    this.initSetting() // 初始化默认配置
  },
  methods: {
    // 初始化数据
    async initSetting() {
      const { id } = this.$route.query
      const { data } = await getOperationDetail(id)
      data.industryList = data.industry
      this.handlerResultMappings([data]) // 处理数据的映射关系
      if (data.priceRange == -1) {
        data.priceRange = '面议'
      }

      if (data.orgTypeStr) {
        data.user.orgTypeStr = data.orgTypeStr
      }
      this.dealInfo('formInfo', data)
      this.dealInfo('userInfo', data.user)

      const { auditStatus } = data
      this.demandStatusOpt = this.auditStatus[auditStatus]
    },
    // 处理静态信息
    dealInfo(type, result) {
      if (!result) return
      if (!this[type]) return
      this[type].forEach(item => {
        const { key } = item
        const v = result[key] || '-'
        item.value = v
        if (item.key === 'orgTypeStr') {
          item.isDetail = true
        }
      })
    }
  }
}
</script>
